export default "__VITE_ASSET__D4mhqJ0g__"